import React from 'react';
import ReactDOM from 'react-dom';
import './index.less';
import App from './App';
import Router from './router/router';
import 'moment/locale/zh-cn';

// const mock = false;
// if (mock) {
//     require('./mock/index');
// }
ReactDOM.render(<Router />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.unregister();
